// src/components/CompletedScreen.js
import React from 'react';
import { Trophy, Award } from 'lucide-react';
import AyseLadyLogo from './AyseLadyLogo';

const CompletedScreen = ({ score, catInfo, onResetGame, onBackToMenu }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-400 to-orange-400 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 text-center max-w-md w-full">
        <AyseLadyLogo />
        <div className="text-6xl mb-4">🏆</div>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Tebrikler!</h2>
        <p className="text-gray-600 mb-6">
          Tüm soruları tamamladın!<br/>
          Final skorun: {score}/200<br/>
          Kedin artık tam büyüdü! {catInfo.stage}
        </p>
        <div className="bg-gradient-to-r from-yellow-100 to-orange-100 p-4 rounded-lg mb-6">
          <Award className="w-8 h-8 text-orange-500 mx-auto mb-2" />
          <p className="text-sm text-gray-700 font-semibold">İngilizce Ustası Sertifikası</p>
          <p className="text-xs text-gray-600">AyseLady.com</p>
        </div>
        <div className="space-y-3">
          <button 
            onClick={onResetGame}
            className="w-full bg-yellow-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-yellow-600 transition-colors"
          >
            <Trophy className="inline mr-2" size={20} />
            Yeniden Başla
          </button>
          <button 
            onClick={onBackToMenu}
            className="w-full bg-gray-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-600 transition-colors"
          >
            Ana Menü
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompletedScreen;